module.exports = __webpack_public_path__ + "img/logo.6781f15e.png";